import React from 'react';

import CouponCta from './CouponCta/CouponCta';
import CTALogin from './CTALogin/CTALogin';
import {ICTATargetCategoryFactoryProps} from './ICTATargetCategoryFactory';

const CTATargetCategoryFactory = ({targetElement, title, targetUrl}: ICTATargetCategoryFactoryProps) => {
	if (!targetElement) {
		return;
	}

	switch (targetElement) {
		case 'CouponCta':
			return <CouponCta label={title} couponCode={targetUrl} />;
		case 'LoginCta':
			return <CTALogin title={title} targetUrl={targetUrl} />;
		default:
			return null;
	}
};

export default CTATargetCategoryFactory;
